import "./DarkCard.css";
import Tag from "./Tag";
import "./Card.css";
import { ReactNode } from "react";
const DarkCard = ({
  tag,
  icon,
  title,
  description,
  image,
}: {
  tag: string;
  icon: ReactNode;
  title: string;
  description: string;
  image: string;
}) => {
  return (
    <div className="card-dark">
      <img className="product2" src={image} alt={title} />
      <div className="card-content">
        <Tag variant="active-color" size="m">
          {icon}
          {tag}
        </Tag>
        <h3 style={{ color: "#E5E5E5" }}>{title}</h3>
        <p className="text-neutral-400">{description}</p>
      </div>
    </div>
  );
};

export default DarkCard;
